export const LOCK_WSPOS = 'lock_wspos';
export const LOCK_WSPOS_SUCCESSFUL = 'lock_wspos_successfull';
export const LOCK_WSPOS_FAILED = 'lock_wspos_failed';



